import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  House, Buildings, ClipboardText, FilePdf, UserCircle, SignOut, FileText,
} from "@phosphor-icons/react";
import { Toaster } from "@/components/ui/sonner";
import { TRENT_LOGO_URL } from "@/components/Logo";

const NAV = [
  { to: "/customer-dashboard", end: true, label: "Dashboard", icon: House, testId: "cust-nav-dashboard" },
  { to: "/customer-dashboard/properties", label: "My Properties", icon: Buildings, testId: "cust-nav-properties" },
  { to: "/customer-dashboard/inspections", label: "Reports", icon: ClipboardText, testId: "cust-nav-inspections" },
  { to: "/customer-dashboard/documents", label: "Documents", icon: FileText, testId: "cust-nav-documents" },
  { to: "/customer-dashboard/account", label: "Account", icon: UserCircle, testId: "cust-nav-account" },
];

export default function CustomerLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A]">
      <header className="sticky top-0 z-30 bg-white border-b border-[#E5E7EB]">
        <div className="mx-auto max-w-[1280px] px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/customer-dashboard" className="flex items-center gap-3" data-testid="cust-brand">
            <img src={TRENT_LOGO_URL} alt="Trent" className="h-9 w-auto" />
            <div className="hidden md:block leading-tight border-l border-[#E5E7EB] pl-3">
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#475569] font-semibold">
                Customer portal
              </div>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex flex-col items-end leading-tight">
              <span className="text-sm font-semibold">{user?.name}</span>
              <span className="text-[11px] text-[#64748B]">{user?.email}</span>
            </div>
            <button onClick={logout} className="p-2 border border-[#E5E7EB] rounded-md hover:bg-[#F1F5F9]" data-testid="cust-logout">
              <SignOut size={18} />
            </button>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-[1280px] flex">
        <aside className="hidden md:block w-56 border-r border-[#E5E7EB] min-h-[calc(100vh-64px)] bg-white">
          <nav className="p-3 space-y-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={n.testId}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium ${
                    isActive ? "bg-[#0F172A] text-white" : "text-[#0F172A] hover:bg-[#F1F5F9]"
                  }`
                }
              >
                <n.icon size={18} weight="duotone" /> {n.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="flex-1 p-4 md:p-8 lg:p-10 min-w-0">
          <Outlet />
        </main>
      </div>

      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5E7EB] z-30 grid grid-cols-5 text-[10px]">
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            className={({ isActive }) =>
              `flex flex-col items-center py-2 ${isActive ? "text-[#0F172A] font-bold" : "text-[#64748B]"}`
            }
          >
            <n.icon size={20} weight="duotone" /> {n.label}
          </NavLink>
        ))}
      </nav>

      <Toaster richColors position="top-right" />
    </div>
  );
}
